import React from 'react';

import WpCalendarPicker from '../WpCalendarPicker';

const CalendarDocs = () => {
  const onChange = value => {
    alert(value);
  };

  return (
    <div>
      <WpCalendarPicker onDateChange={onChange} />
    </div>
  );
};

export default CalendarDocs;
